export default "__VITE_ASSET__JujJOY0V__"